const paperLg = {
  variant: 'cards.primary',
  p: [4, 5]
}

export default paperLg
